var _path, _path2, _path3, _path4, _path5, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,100C22.4,100,0,77.6,0,50C0,22.4,22.4,0,50,0s50,22.4,50,50C100,77.6,77.6,100,50,100z M50,2C23.6,2,2,23.6,2,50  s21.5,48,48,48s48-21.5,48-48S76.4,2,50,2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50,49c-0.1,0-0.1,0-0.2,0l-33.3-6.7c-0.5-0.1-0.8-0.5-0.8-1s0.3-0.9,0.8-1l33.3-7.8c0.2,0,0.3,0,0.5,0l33.3,7.8  c0.5,0.1,0.8,0.5,0.8,1s-0.4,0.9-0.8,1l-33.3,6.7C50.1,49,50.1,49,50,49z M21.5,41.1L50,46.9l28.5-5.8L50,34.4L21.5,41.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51,67.7c-0.4,0-0.7,0-1.1,0c-8,0.4-20.7-3.7-21.5-4.4L28.1,63l0-0.4V46.6L50,51l19.8-4.4V63l-0.3,0.3  C68.8,63.8,58.6,67.7,51,67.7z M30.2,61.8c2.5,1,12.6,4.1,19.7,3.8c6.3,0.3,15.5-2.8,17.8-3.8V49.2L50,53.1l-19.8-4V61.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75,42.7c0,0-25.1-2.1-25.1-2.1c-0.6,0-1-0.6-1-1.1c0-0.6,0.6-1,1.1-1l25,2.1C75.7,40.7,75.5,42.7,75,42.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75,57.3c-0.6,0-1-0.5-1-1V41.7c0-0.6,0.5-1,1-1s1,0.5,1,1v14.6C76,56.8,75.6,57.3,75,57.3z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 58.3,
    width: 2.1,
    height: 4.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.a6497453ef783e2588cf121bd2dc6976.svg";
export { ForwardRef as ReactComponent };